import { assertString } from '@watershed/lscript/assert';
import { ASTCall, stringifyExpr } from '@watershed/lscript/ast';
import { evalExpression } from '../eval';
import { ExprType, stringifyType } from '@watershed/lscript/expr_types';
import { exprToSql } from '../sql';
import {
  assertArgShape,
  assertKwargShape,
  TypecheckWarning,
  typecheckExpression,
} from '../typecheck';
import { Context, Func, SqlExpression } from '../types';

// Return an error if evaluated.
// error("oh no!")
export const error: Func = {
  typecheck(
    ctx: Context,
    call: ASTCall,
    warnings?: Array<TypecheckWarning>
  ): ExprType {
    assertArgShape(call, 1, 1);
    assertKwargShape(call, [], false);
    const arg = typecheckExpression(ctx, call.args[0], warnings);
    if (arg.ty !== 'string') {
      warnings?.push(
        `Expected ${stringifyExpr(
          call.args[0]
        )} to be string, but got ${stringifyType(arg)}`
      );
    }
    // Really, `never`, but we don't have that type yet
    return { ty: 'null' };
  },

  eval(ctx: Context, call: ASTCall): unknown {
    const arg = evalExpression(ctx, call.args[0]);
    throw new Error(assertString(arg));
  },

  toSql(ctx: Context, call: ASTCall): SqlExpression {
    const arg = exprToSql(ctx, call.args[0]);
    return {
      expr: 'null',
      stage: arg.stage,
      unitExpr: null,
      error: {
        exists: `${arg.expr} IS NOT NULL`,
        expr: arg.expr,
      },
      trace: null,
    };
  },
};
